import React from 'react';

const Vue_slot = () => {
  return (
    <div>
      <h1>Vue_slot Component</h1>
      <p>This is the Vue_slot tutorial page.</p>
    </div>
  );
}

export default Vue_slot;
